// removed by extract-text-webpack-plugin
module.exports = {"title":"styles__title___z-R48","meta":"styles__meta___uNipC","rotate":"styles__rotate___MsYNl","fadein":"styles__fadein___tx4XN","slideFromRight":"styles__slideFromRight___1SI78","waves":"styles__waves___1oEbf"};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/ResultListItem/styles.scss
// module id = ./resources/assets/js/components/ResultListItem/styles.scss
// module chunks = 0